import { useEffect, useState } from "react";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import MaterialTableTS from "../../../../components/tables/MaterialTableTS";
import ButtonForModal from "../../../../components/ButtonForModal";
import AddButton from "../../../../components/AddButton";
import ConfirmBoxDelete from "../../../../components/ConfirmBoxDelete";
import { PencilSquareIcon } from "@heroicons/react/24/solid";
import {
  officeVendorAddState,
  officeVendorEditState,
  OfficeVendorModal,
  OfficeVendorSvcViewData,
  rowForEditOfficeSettings,
  DisableOfficeField,
} from "../atoms/atoms";
import { useGetOfcVendorServiceForEdit } from "../hooks/useGetOfcVendorSvcForEdit";
import useDeactivateOfcVendorSvc from "../hooks/useDeactivateOfficeVendorService";
import { useQueryClient } from "react-query";
import { toast } from "../../../../components/toastNotification";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { selectedRowsStateOVS } from "../../Vendor/atoms/atoms";
import { OFFICE_PERMISSIONS } from "../permission";

const OfficeVendorServiceViewAll = ({ data }) => {
  const queryClient = useQueryClient();
  const [openModalDelete, setOpenModalDelete] = useState(false);
  const [selectedRowsToDelete, setSelectedRowsToDelete] =
    useRecoilState(selectedRowsStateOVS);
  const userPermissions = useRecoilValue(permissionsSelector);
  const editOfficeVendor = OFFICE_PERMISSIONS.permission_office_vendor_edit;
  const addOfficeVendor = OFFICE_PERMISSIONS.permission_office_vendor_add;
  const deleteOfficeVendor = OFFICE_PERMISSIONS.permission_office_vendor_delete;

  //const BulkDeleteVendor = useDeactivateOfcVendorSvc();
  const {
    mutate: BulkDeleteVendor,
    isSuccess: deacSuccess,
    data: deacResult,
    reset: resetDeacData,
  } = useDeactivateOfcVendorSvc();

  const [disabledButton, setDisabledButton] = useState(false);
  const setRowToEdit = useSetRecoilState(rowForEditOfficeSettings);
  const setDisableOfficeField = useSetRecoilState(DisableOfficeField);
  const [, setOfficeVendorServiceEditState] = useRecoilState(
    officeVendorEditState
  );

  const [, setRowViewData] = useRecoilState(OfficeVendorSvcViewData);
  const [, setShowOfficeVendorForm] = useState(false);
  const [, setOfficeVendorServiceAddState] =
    useRecoilState(officeVendorAddState);
  const [, setOfcVendorServiceShow] = useRecoilState(OfficeVendorModal);

  const {
    mutate: getOfcVendorServiceForEdit,
    isLoading: OfcVendorServiceoading,
  } = useGetOfcVendorServiceForEdit();

  useEffect(() => {
    setSelectedRowsToDelete([]);
  }, [setSelectedRowsToDelete]);

  const handleEdit = (rowDetails) => {
    setDisableOfficeField(true);
    getOfcVendorServiceForEdit(rowDetails.recordNumber, {
      onSuccess: (res) => {
        setRowToEdit({
          ...res,
          inactiveAccount: res.inactiveAccount ? "True" : "False",
          vendorCode: rowDetails.vendorCode,
        });
        if (!OfcVendorServiceoading) setOfficeVendorServiceEditState(true);
      },
    });
  };

  const onClickOfficeVendorService = (rowData) => {
    setOfcVendorServiceShow(true);
    setRowViewData(rowData);
  };

  if (deacSuccess && deacResult) {
    if (deacResult.status === 201 || deacResult.status === 200) {
      toast.fire(
        "Success",
        "Office Vendor Services were deactivated successfully",
        "success"
      );
      queryClient.invalidateQueries(
        "GetOfficeVendorServiceByOfficeId",
        data?.officeId
      );
      setSelectedRowsToDelete(undefined);
      //ssearchRefetch();
    } else if (deacResult.status === 500) {
      if (
        deacResult.data.message ===
          "Service not available, closing transmission channel. The server response was: 4.3.2 Service not available" ||
        deacResult.data.message ===
          "Service not available, closing transmission channel. The server response was: 4.3.2 Service not available"
      ) {
        toast.fire(
          "Warning",
          "Office Vendor Services were successfully deactivated, but " +
            deacResult.data.message,
          "warning"
        );
      } else {
        toast.fire(
          "Bulk deactivation of Office Vendor Services failed",
          "Server Error: Cannot deactivate Office Vendor Services",
          "error"
        );
      }
      queryClient.invalidateQueries(
        "GetOfficeVendorServiceByOfficeId",
        data?.officeId
      );
    } else {
      toast.fire(
        "Bulk deactivation of Office Vendor Services failed",
        "Server Error: Cannot deactivate Office Vendor Services",
        "error"
      );
      queryClient.invalidateQueries(
        "GetOfficeVendorServiceByOfficeId",
        data?.officeId
      );
    }
    resetDeacData();
  }

  const Materialcolumns = [
    {
      title: "Record Number",
      render: (rowdata) => {
        return (
          // <span className="pr-2">
          //   {"MS-" + String(rowdata.recordNumber)?.padStart(4, "0")}
          // </span>
          <div
            className="blueAndBold underline expandedData fontExpand text-xs cursor-pointer"
            onClick={() => onClickOfficeVendorService(rowdata)}
          >
            {rowdata.recordNumber
              ? "MS-" + String(rowdata.recordNumber).padStart(4, "0")
              : ""}
          </div>
        );
      },
      customFilterAndSearch: (term, rowData) =>
        ("MS-" + String(rowData.recordNumber)?.padStart(4, "0"))
          .toLowerCase()
          .indexOf(term.toLowerCase()) !== -1,
    },
    { title: "Office Name", field: "officeName" },
    { title: "Vendor Name", field: "vendorName" },
    { title: "Vendor Code", field: "vendorCode" },
    { title: "Account Number", field: "accountNumber" },
    { title: "Contact", field: "contact" },
    { title: "Phone Number", field: "phone" },
    { title: "Meter Number", field: "meterNumber" },
    { title: "Service Provided", field: "servicesProvided" },
    {
      title: "Status",
      field: "isActive",
      lookup: { true: "Active", false: "InActive" },
      searchable: true,
    },
    {
      title: "Action/s",
      align: "center",
      render: (rowData) => {
        return (
          <div className=" flex justify-center">
            {userPermissions.includes(editOfficeVendor) && (
              <ButtonForModal
                className={
                  " border border-quaternary text-white bg-quaternary  "
                }
                onClick={() => {
                  handleEdit(rowData);
                }}
              >
                <PencilSquareIcon className="h-4 w-4" />
                Edit
              </ButtonForModal>
            )}
          </div>
        );
      },
    },
  ];

  const handleSelectedRowsChange = (rows) => {
    const forDelete = rows
      .filter((x) => x.isActive)
      .map((r) => {
        const { tableData, ...rows } = r;
        return rows;
      });
    setSelectedRowsToDelete(forDelete);
  };

  const handleBulkDelete = () => {
    const ids = selectedRowsToDelete
      .filter((x) => x.isActive === true)
      .map((row) => row.recordNumber);
    const data = {
      id: ids,
      fromModule: "Office",
    };
    BulkDeleteVendor(data);
    //setSelectedRowsToDelete(ids);
    setOpenModalDelete(false);
    setDisabledButton(false);
  };

  const deleteMessage = (
    <div className="text-gray-500 font-normal">{`Are you sure you want to deactivate ${
      selectedRowsToDelete?.length
    } ${
      selectedRowsToDelete?.length > 1
        ? "Office Vendor Services"
        : "Office Vendor Service"
    } ?`}</div>
  );
  //Function for Add Button on Security
  const onClickOfficeVendorModal = () => {
    setShowOfficeVendorForm(true);
    setOfficeVendorServiceAddState(true);
    setOfficeVendorServiceEditState(true);
    setDisableOfficeField(true);
    setRowToEdit([]);
  };

  return (
    <>
      <div className="">
        <div className="">
          <div className="text-base text-primary font-bold pl-3 pb-2">
            Office Vendor Service
          </div>
          <div className="mr-3 ml-3 border-b-2 border-secondary"></div>
        </div>
        <div className="w-full space-y-2">
          <div className="flex flex-row justify-between p-2">
            <div className="text-secondary italic text-xs3 mx-2 mt-2">
              <div>
                <p className="font-bold italic inline-block mr-1">Note: </p>
                Tick the box to deactivate some data.
              </div>
            </div>
            <div className="flex flex-row justify-between mt-2">
              <div className="mr-2">
                {userPermissions.includes(addOfficeVendor) && (
                  <AddButton
                    buttonText="Add"
                    className={
                      selectedRowsToDelete?.length > 0
                        ? "opacity-50"
                        : "opacity-100"
                    }
                    onClick={() => onClickOfficeVendorModal()}
                    disabled={
                      disabledButton || selectedRowsToDelete?.length > 0
                    }
                  />
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="grid-row mx-4 shadow-xl">
          <MaterialTableTS
            showToolbar={true}
            toolbarSearch={true}
            columns={Materialcolumns}
            data={data}
            selection={userPermissions.includes(deleteOfficeVendor)}
            selectedRows={selectedRowsToDelete}
            setConfirmModalOpen={setOpenModalDelete}
            onSelectionChange={handleSelectedRowsChange}
            isLoading={false}
          />
        </div>
      </div>
      {
        <ConfirmBoxDelete
          ModalTitle="Deactivate Office Vendor Service"
          qConfirmation={deleteMessage}
          isOpen={openModalDelete}
          onClose={() => setOpenModalDelete(false)}
          onClickFunction={handleBulkDelete}
        />
      }
    </>
  );
};

export default OfficeVendorServiceViewAll;
